import Script from 'next/script';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export var GoogleScripts = function GoogleScripts() {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Script, {
      id: "google-gtm",
      strategy: "afterInteractive",
      children: "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n        })(window,document,'script','dataLayer','".concat(process.env.NEXT_PUBLIC_GTM_ID, "')")
    }), /*#__PURE__*/_jsx(Script, {
      src: "https://www.googletagmanager.com/gtag/js?id=".concat(process.env.NEXT_PUBLIC_GANALYTICS_ID),
      strategy: "afterInteractive"
    }), /*#__PURE__*/_jsx(Script, {
      id: "google-datalayer",
      children: "window.dataLayer = window.dataLayer || [];\n        function gtag(){dataLayer.push(arguments);}\n        gtag('js', new Date());\n        gtag('config','".concat(process.env.NEXT_PUBLIC_GTAG_ID, "');")
    })]
  });
};